import { render, staticRenderFns } from "./extraInstruction.vue?vue&type=template&id=3bf633d2&scoped=true&"
import script from "./extraInstruction.vue?vue&type=script&lang=js&"
export * from "./extraInstruction.vue?vue&type=script&lang=js&"
import style0 from "./extraInstruction.vue?vue&type=style&index=0&id=3bf633d2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bf633d2",
  null
  
)

export default component.exports